module.exports = __webpack_public_path__ + "img/HZ-G1200.8c911306.jpg";